import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import CompetitiveSwimming from './pages/CompetitiveSwimming';
import Committee from './pages/Committee';
import NewPoolUpdates from './pages/NewPoolUpdates';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import Events from './pages/Events';
import Results from './pages/Results';
import MastersInterest from './pages/MastersInterest';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/competitive" element={<CompetitiveSwimming />} />
          <Route path="/committee" element={<Committee />} />
          <Route path="/new-pool" element={<NewPoolUpdates />} />
          <Route path="/masters-interest" element={<MastersInterest />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/events" element={<Events />} />
          <Route path="/results" element={<Results />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;